<template>
  <div class="containers">
    <SectionHeader>
      <template v-slot:breadcrumbs>
        <BreadCrumbs
          :items="[
            { text: $t('notifications.many'), name: 'all_notifications' },
            { text: $t('notifications.addTopic') },
          ]"
        />
      </template>
    </SectionHeader>

    <div class="body-content">
      <div class="entries-wrap">
        <div class="content-wrap">
          <header class="content-header cf">
            <h3>{{ $t('notifications.createTopic') }}</h3>
          </header>
          <div class="content-body">
            <Form v-model="notification_topic" @submit="createTopic" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Form from '@/views/notifications/topics/Form.vue'

import BreadCrumbs from '@/components/BreadCrumbs'
import SectionHeader from '@/components/SectionHeader'

import notificationTopicsApi from '@/api/notificationTopics'

export default {
  name: 'new_notification_topic',
  inject: ['companyUser'],
  components: { BreadCrumbs, SectionHeader, Form },
  data() {
    return {
      notification_topic: this.defaultNotificationTopic(),
    }
  },
  methods: {
    createTopic: async function (topic) {
      const response = await notificationTopicsApi.create({
        company_uuid: this.companyUser.company_uuid,
        ...topic,
      })
      if (response.success) {
        await this.$router.push('/notifications')
      }
    },
    defaultNotificationTopic() {
      if (this.companyUser.company_type == 'branch') {
        return {
          type: 'fill_level',
          matcher: 'greater_than',
          value: 80,
          interval: 'instant',
          project_uuid: null,
          channel_uuids: [],
        }
      } else if (this.companyUser.company_type == 'industry') {
        return {
          type: 'order',
          order_type: 'emptying_order',
          action: 'created',
          channel_uuids: [],
        }
      }
    },
  },
}
</script>
